import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { PropTypes } from 'prop-types';

const SkeletonAdmin = (props) => {
  const { width, height, styleProps } = props;
  return <Skeleton variant="rect" width={width} style={styleProps} height={height} />;
};

SkeletonAdmin.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  styleProps: PropTypes.string,
};

SkeletonAdmin.defaultProps = {
  height: '20',
  width: '20',
  styleProps: {},
};

export default SkeletonAdmin;
